import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/react-query'
import service from './systemVariable.service'

const useSystemVariable = () => {
  const baseCrud = useCrud(API_RESOURCE.SYSTEM_VARIABLE, service)

  const queryClient = useQueryClient()

  const useFetchAllSystemVariables = (type, parameter) => {
    const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = parameter

    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page, pageSize, filters: { ...filters, type: type }, sortBy, orderBy })],
      queryFn: () => service.fetchAll({ page, pageSize, filters: { ...filters, type: type }, sortBy, orderBy }),
      placeholderData: keepPreviousData,
    })
  }

  const useSystemVariableOptions = (type, { status = 'active', valueKey = 'name', labelKey = 'name', ...rest }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status, ...rest, type: type } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status, ...rest, type: type } }),
      placeholderData: keepPreviousData,
      select: (data) => createOptions(data?.data, labelKey, valueKey),
    })
  }

  return {
    //Base CRUD
    useFetchAllSystemVariables: useFetchAllSystemVariables,
    //Extra
    useSystemVariableOptions,
  }
}

export default useSystemVariable
